import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../../route';

const SdSupplierDetailPage = lazyRouteComponent(
  () => import('../SdSupplierDetailPage'),
  'SdSupplierDetailPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/suppliers/$companyId',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: SdSupplierDetailPage,
  loader: () => ({
    crumb: msg('Supplier', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
